import { ICommonSettings, ISearchServiceSettings } from "@kuika/kuika-cl-model";
import { PureComponent, ReactNode } from "react";
import { ICommonConfigDeleteFunctionParams, ICommonConfigSaveFunctionParams } from "../app-settings-config-container";
import { ConfigSettingSelect } from "../config-setting-select";
import { ConfigSearchServiceSettings } from "./app-settings-config-search-service";

export interface IConfigSearchServiceInputState {
  showModal: boolean;
  editingSearchServiceId: string;
}

export interface IConfigSearchServiceInputProps {
  parentConfigValue?: string | null;
  commonSettings: ICommonSettings;
  getSectionDescription: (contentKey: string) => ReactNode;
  handleUpdateCustomFormInput?: (formItemName: string[], value: string | null) => void;
  handleCreateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleUpdateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleDeleteCommonConfig: (params: ICommonConfigDeleteFunctionParams) => void;
}

export class ConfigSearchServiceInput extends PureComponent<
  IConfigSearchServiceInputProps,
  IConfigSearchServiceInputState
> {
  formInputName = ["apiConfig", "searchServiceSettingsId"];

  constructor(props: IConfigSearchServiceInputProps) {
    super(props);
    this.state = {
      showModal: false,
      editingSearchServiceId: ""
    };
  }

  openModal = () => {
    this.setState({ showModal: true, editingSearchServiceId: "" });
  };

  closeModal = () => {
    this.setState({ showModal: false });
  };

  setEditingSetting = (id: string) => {
    this.setState({ editingSearchServiceId: id, showModal: true });
  };

  handleRestore = (): void => {
    this.props.handleUpdateCustomFormInput?.(this.formInputName, this.props.parentConfigValue ?? null);
  };

  render() {
    const {
      parentConfigValue,
      commonSettings,
      getSectionDescription,
      handleUpdateCustomFormInput,
      handleCreateCommonConfig,
      handleUpdateCommonConfig,
      handleDeleteCommonConfig
    } = this.props;

    const options = [
      { id: null, name: "Default" } as unknown as ISearchServiceSettings,
      ...(commonSettings.searchServiceSettings || [])
    ];
    return (
      <>
        <ConfigSearchServiceSettings
          formInputName={this.formInputName}
          closeModal={this.closeModal}
          showModal={this.state.showModal}
          editingSearchServiceId={this.state.editingSearchServiceId}
          commonSettings={commonSettings}
          getSectionDescription={getSectionDescription}
          handleCreateCommonConfig={handleCreateCommonConfig}
          handleUpdateCommonConfig={handleUpdateCommonConfig}
          handleDeleteCommonConfig={handleDeleteCommonConfig}
        />
        <ConfigSettingSelect
          label="Configuration"
          formInputName={this.formInputName}
          options={options}
          allowClear
          tooltipContentKey="appsettings_searchservice_configuration"
          onAddNew={this.openModal}
          onEdit={this.setEditingSetting}
          parentConfigValue={this.props.parentConfigValue}
          onRestore={this.handleRestore}
          dropdownTestId="appSettingsSearchServiceDropdown"
          addNewTestId="appSettingsSearchServiceAddNewButton"
          editTestId="appSettingsSearchServiceEditButton"
        />
      </>
    );
  }
}
